import {
    DEALERFEEEXCELPDFFILE_FAILED,
    DEALERFEEEXCELPDFFILE_SUCCESS,
    RESET_DEALERFEEEXCELPDFFILE,
    LOADING_DEALERFEEEXCELPDFFILE,
    NETWORK_ERROR_DEALERFEEEXCELPDFFILE
} from '../types/index'

import { dealerServices } from "../../config/axios";


const resetDealerFeeExcelPdfFileList = () => {
    return { type: RESET_DEALERFEEEXCELPDFFILE };
};

const dealerFeeExcelPdfFile = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERFEEEXCELPDFFILE });
    await dealerServices
        .post("feeExcelPdfFile", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerFeeExcelPdfFilesuccess(res.data));
                    break;
                default:
                    dispatch(dealerFeeExcelPdfFileFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERFEEEXCELPDFFILE,
                payload: err
            });
        });
};

function dealerFeeExcelPdfFilesuccess(data) {
    return {
        type: DEALERFEEEXCELPDFFILE_SUCCESS,
        payload: data
    };
}
function dealerFeeExcelPdfFileFailed(data) {
    return {
        type: DEALERFEEEXCELPDFFILE_FAILED,
        payload: data
    };
}

export { resetDealerFeeExcelPdfFileList, dealerFeeExcelPdfFile }